module.exports = __webpack_public_path__ + "img/4.86098239.jpg";